import React, { FC } from 'react'

import { IconMinutesSmsProps } from './IconMinutesSms.types'
import * as Styled from './styles/IconMinutesSms.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMinutesSms: FC<IconMinutesSmsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMinutesSmsProps['size'],
  isResponsive = false,
}: IconMinutesSmsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M38.566 9.027h-9.132m9.132 3.946h-9.132' stroke='#E60000' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path d='M42.902 8.063V5.19H40' stroke='#0D0D0D' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='1.95' />
        <path
          d='M40 5.191H27.324c-1.23.004-2.226 1-2.226 2.23v7.415c0 .594.234 1.156.652 1.574.414.418.98.652 1.574.652h8.305l4.305 4.067v-4.067h.75a2.227 2.227 0 0 0 2.226-2.226V8.062'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M15.898 10.14c.79 2.204 1.579 4.403 2.364 6.602l.062.172a.753.753 0 0 1-.25.848 8.83 8.83 0 0 1-2.539 1.336c-1.094.34-2.219.558-3.36.652a.732.732 0 0 0-.624.945 24.651 24.651 0 0 0 6.043 9.942 24.716 24.716 0 0 0 10 6.011.73.73 0 0 0 .914-.48c.012-.047.023-.09.027-.137.098-1.137.32-2.254.664-3.34a8.687 8.687 0 0 1 1.34-2.52.744.744 0 0 1 .86-.25l.167.06 6.637 2.35c1.578.56 3.633 1.15 4.73 1.684.016 0 0 .032 0 .051a6.804 6.804 0 0 1-.285 2.512c-.75 2.438-2.773 5.05-5.164 5.75-6.03 1.8-12.382-.043-18-2.86A24.254 24.254 0 0 1 8.72 28.75c-2.841-5.578-4.69-11.898-2.884-17.9.715-2.375 3.344-4.39 5.793-5.136l1.894-.5c.36-.094.73.105.848.457l1.527 4.468Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconMinutesSms
